export default __webpack_public_path__ + "static/media/games.a506e5e7.png";